import { render } from "./CallPage.vue?vue&type=template&id=4f340950&scoped=true"
import script from "./CallPage.vue?vue&type=script&lang=js"
export * from "./CallPage.vue?vue&type=script&lang=js"

import "./CallPage.vue?vue&type=style&index=0&id=4f340950&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f340950"]])

export default __exports__